module.exports = __webpack_public_path__ + "static/media/BG_Mythic.8e8238bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/BG_Mythic.png
// module id = 1259
// module chunks = 0